import { render, staticRenderFns } from "./add_capability_modal.vue?vue&type=template&id=ff3ece98"
import script from "./add_capability_modal.vue?vue&type=script&lang=js"
export * from "./add_capability_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports